const NotepadIcon = (props) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M9.58333 1.14583C9.58333 0.512917 9.07042 0 8.4375 0H3.64583C3.01292 0 2.5 0.512917 2.5 1.14583V6.77083C2.5 7.40375 3.01292 7.91667 3.64583 7.91667H8.4375C9.07042 7.91667 9.58333 7.40375 9.58333 6.77083V1.14583ZM7.60417 6.04167H4.47917C4.30667 6.04167 4.16667 5.90167 4.16667 5.72917C4.16667 5.55667 4.30667 5.41667 4.47917 5.41667H7.60417C7.77667 5.41667 7.91667 5.55667 7.91667 5.72917C7.91667 5.90167 7.77667 6.04167 7.60417 6.04167ZM7.60417 4.79167H4.47917C4.30667 4.79167 4.16667 4.65167 4.16667 4.47917C4.16667 4.30667 4.30667 4.16667 4.47917 4.16667H7.60417C7.77667 4.16667 7.91667 4.30667 7.91667 4.47917C7.91667 4.65167 7.77667 4.79167 7.60417 4.79167ZM7.60417 3.54167H4.47917C4.30667 3.54167 4.16667 3.40167 4.16667 3.22917C4.16667 3.05667 4.30667 2.91667 4.47917 2.91667H7.60417C7.77667 2.91667 7.91667 3.05667 7.91667 3.22917C7.91667 3.40167 7.77667 3.54167 7.60417 3.54167Z"
        fill="#534E66"
      />
      <path
        d="M3.64616 8.54199C2.66949 8.54199 1.87533 7.74741 1.87533 6.77116V1.14616C1.87533 1.11033 1.88366 1.07699 1.88574 1.04199H1.56283C0.930742 1.04199 0.416992 1.55574 0.416992 2.18783V8.85449C0.416992 9.48658 0.930742 10.0003 1.56283 10.0003H6.56282C7.19491 10.0003 7.70866 9.48658 7.70866 8.85449V8.54199H3.64616Z"
        fill="#534E66"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default NotepadIcon;
